import z from 'zod';

export const ShopItemRewardSchema = z.enum([
  'CashReward',
  'FreeSpins',
  'Physical',
  'MysteryBox',
]);

export const PurchasedItemRewardTypeSchema = z.enum([
  'FreeSpins',
  'CashReward',
  'CoinsReward',
]);

export const ShopItemSale = z.object({
  id: z.number(),
  price: z.number(),
  percentage: z.number(),
  availableItems: z.number().optional(),
  displayAvailableItems: z.boolean(),
  label: z.string().optional(),
});

export const MysterBoxItemDropSchema = z.object({
  weight: z.number(),
  type: PurchasedItemRewardTypeSchema,
  isTopPrize: z.boolean(),
  amount: z.number().optional(),
  coinsBackupValue: z.number().optional(),
  freeSpinsCoinValue: z.number().optional(),
  freeSpinsCount: z.number().optional(),
  freeSpinsGameName: z.string().optional(),
});

export const MysteryBoxConfigurationSchema = z.object({
  itemDrops: z.array(MysterBoxItemDropSchema),
});

export const ShopItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: ShopItemRewardSchema,
  price: z.number(),
  description: z.string().optional(),
  thumbnail: z.string(),
  availableFrom: z.string().datetime().optional(),
  isBestValue: z.boolean(),
  sale: ShopItemSale.optional(),
  lastPurchasedAt: z.string().datetime().optional(),
  mysteryBoxConfiguration: MysteryBoxConfigurationSchema.optional(),
});

export const ShopItemsResponseSchema = z.object({
  items: z.array(ShopItemSchema),
});

export const PurchasedItemStatusSchema = z.enum(['Awarded', 'BackupAwarded']);

export const PurchasedItemSchema = z.object({
  type: PurchasedItemRewardTypeSchema,
  status: PurchasedItemStatusSchema,
  amount: z.number(),
  freeSpinsGameId: z.number().optional(),
  freeSpinsCoinValue: z.number().optional(),
  coinsBackupValue: z.number().optional(),
});

export const ShopItemPurchaseResponseSchema = z.object({
  playerId: z.number(),
  amount: z.number(),
  coinBalance: z.number(),
  purchasedItems: z.array(PurchasedItemSchema),
});

export const ShopSaleSchema = z.object({
  name: z.string(),
  id: z.number(),
  availableFrom: z.string().datetime(),
  fromCountdownEnabled: z.boolean(),
  availableTo: z.string().datetime(),
  toCountdownEnabled: z.boolean(),
  bannerImage: z.string().optional(),
});

export const ShopSalesResponseSchema = z.object({
  systemTime: z.string().datetime(),
  sales: z.array(ShopSaleSchema),
});
